<template>
  <div class="custom-search-select">
    <div class="search-content" v-popover:popover>
      <span v-show="selectValueList.length === 0" class="placeholder">{{ placeholder }}</span>
      <div class="search-content-item" v-for="item in selectValueList" :key="item.value">
        <div class="search-content-item-text">{{ item.label }}</div>
        <div class="search-content-item-icon" @click.stop="deleteSelectHandle(item)"><i class="el-icon-error"></i></div>
      </div>
    </div>
    <el-popover
      ref="popover"
      popper-class="popover-class"
      placement="bottom-start"
      width="280"
      trigger="click"
      @show="searchKey = ''"
    >
      <div class="option">
        <el-input
          v-model="searchKey"
          size="mini"
          :placeholder="searchPlaceholder"
          clearable
        ></el-input>
        <div class="option-contain">
          <div
            class="option-contain-item"
            :class="[selectValueList.find(ite => ite.value === item.value) ? 'checked' : '']"
            v-for="item in resultOptions"
            :key="item.value"
            @click.stop="checkItemHandle(item)"
          >
            <div class="option-contain-item-text">{{ item.label }}</div>
            <div class="option-contain-item-icon">
              <i class="el-icon-check"></i>
            </div>
          </div>
        </div>
        <div v-show="resultOptions.length <= 0" class="option-no-data">未搜索到数据</div>
      </div>
    </el-popover>
    <div class="search-clear-icon" :class="{ 'visible': selectValueList.length > 0 }">
      <i
        class="icon el-icon-circle-close"
        style="color: #999;cursor: pointer;"
        @click.stop="clearHandle"
      ></i>
    </div>
    <div class="search-arr-icon">
      <i class="icon el-icon-arrow-down"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'customSearchSelect',
  data() {
    return {
      searchKey: '',
      resultOptions: []
    }
  },
  methods: {
    clearHandle() {
      this.selectValueList = []
      this.$emit('change', this.selectValueList)
    },
    checkItemHandle(itemInfo) {
      const index = this.selectValueList.findIndex(item => item.value === itemInfo.value)
      if (index > -1) {
        this.selectValueList.splice(index, 1)
      } else {
        this.selectValueList.push(itemInfo)
      }
      this.$emit('change', this.selectValueList)
    },

    deleteSelectHandle(itemInfo) {
      const index = this.selectValueList.findIndex(item => item.value === itemInfo.value)
      if (index > -1) {
        this.selectValueList.splice(index, 1)
      }
      this.$emit('change', this.selectValueList)
    }
  },
  props: {
    placeholder: {
      type: String,
      default: '请选择'
    },
    searchPlaceholder: {
      type: String,
      default: '请输入'
    },
    value: {
      type: Array,
      default: () => ([])
    },
    options: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    selectValueList: {
      get() {
        return this.value
      },
      set(val) {
        console.log(val)
        this.$emit('input', val)
      }
    }
  },
  watch: {
    searchKey: {
      handler(newValue) {
        this.resultOptions = newValue === '' ? this.options.slice(0, 100) : this.options.filter(item => item.label.includes(newValue))
      }
    },
    options: {
      handler(val) {
        this.resultOptions = val.slice(0, 100)
      },
      immediate: true
    }
  }
}

</script>

<style scoped lang='less'>
.custom-search-select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 2px;
  flex: 1;
  gap: 6px;
  min-width: 240px;
  min-height: 32px;
  border: 1px solid rgb(211, 211, 213);
  border-radius: 4px;

  .search-content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    width: calc(100% - 60px);
    min-height: 32px;
    outline: none;

    .placeholder {
      display: inline-block;
      height: 32px;
      line-height: 32px;
      padding-left: 10px;
      font-size: 14px;
      color: #999;
    }

    .search-content-item {
      display: flex;
      justify-content: flex-start;
      gap: 4px;
      padding: 0 6px;
      background-color: #e9e9e9;
      height: 20px;
      line-height: 20px;
      border-radius: 4px;
      margin: 4px;

      .search-content-item-text {
        font-size: 12px;
      }

      .search-content-item-icon {
        cursor: pointer;
        color: #999;
      }
    }
  }


  .search-clear-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    visibility: hidden;
  }

  &:hover {
    .search-clear-icon.visible {
      visibility: visible;
    }
  }

  .search-arr-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
  }
}
</style>

<style>
.popover-class {

  .option {
    .option-contain {
      margin: 6px 0;
      max-height: 300px;
      overflow-y: auto;
  
      .option-contain-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 10px;
        cursor: pointer;
        user-select: none;
  
        .option-contain-item-icon {
          display: none;
        }
  
        &.checked {
          color: #1890ff;
  
          .option-contain-item-icon {
            display: block;
          }
        }
      }
    }
    .option-no-data {
      text-align: center;
      padding: 2px 10px 2px;
      color: #999;
    }
  }

}
</style>